// extracted by mini-css-extract-plugin
module.exports = {"ComputeCreditWidget":"ComputeCreditWidget_ComputeCreditWidget__1d5hz","Card":"ComputeCreditWidget_Card__wbKYf","ChartContainer":"ComputeCreditWidget_ChartContainer__b03wK"};